import { isNullOrEmpty } from "../../utilidades/isNullOrEmpty";
import i18next from "i18next";

export function templateCardInfoFanpage(data) {

   const capaELogo = (fotoLogo, empresaFantasia, fotoCapaUrl) => {
      let classCapa = !isNullOrEmpty(fotoCapaUrl) ? `class="capa-tamanho border-top-radius img-fluid w-100" style="background-image: url('${fotoCapaUrl}'); max-height: 240px!important;"` : 'class="capa-tamanho border-top-radius img-fluid w-100" style="height: 220px!important;"'
      return `<div class="position-relative mb-4 rounded-2" style="margin-left: -1.5rem; margin-right: -1.5rem; margin-top: -1.5rem;">
                  <div ${classCapa}></div>
                  <div class="position-absolute" style="bottom: -40px; left: 50%; transform: translateX(-50%);">
                     <img src="${fotoLogo}"
                        alt="${empresaFantasia}"
                        itemprop="image"
                        class="rounded-circle border border-4 border-white bg-white shadow-sm"
                        style="width: 100px; height: 100px; object-fit: contain;" />
                  </div>
               </div>`;
   };

   const nomeEmpresa = (empresaFantasia, areaNome) => {
      let area = !isNullOrEmpty(areaNome) ? `<p class="text-muted mb-0">${areaNome}</p>` : "";
      return `<div class="text-center mt-5 pt-3 mb-4">
                     <h2 class="h4 fw-bold mb-1">${empresaFantasia}</h2>
                     ${area}
               </div>`
   };

   const imagemVideoApresentacao = (tipoArquivo, arquivoUrl, empresaFantasia, idVideo) => {
      if (tipoArquivo.toLowerCase() === 'video' && !isNullOrEmpty(arquivoUrl) && !isNullOrEmpty(idVideo)) {
         return `<div class="ratio ratio-16x9 mb-4" id="containerVideo" data-urlVideo="${arquivoUrl}" data-idVideo="${idVideo}" data-titleVideo="Video da empresa:${empresaFantasia}">
                     <div class="player">
                     </div>
                  </div>`;
      }
      else if (tipoArquivo.toLowerCase() === 'imagem' && !isNullOrEmpty(arquivoUrl)) {
         return `<div class="mb-4">
                     <img src="${arquivoUrl}" alt="${empresaFantasia}" class="img-fluid w-100" style="max-height: 400px; object-fit: cover;">
                 </div>`;
      }

      return '';
   };

   const sobreEmpresa = (empresaFantasia, sobre, porqueTrabalhar) => {
      let html = "";
      // Os campos vem do editor de texto rico: envolver em <p> faz o parser fechar o paragrafo na
      // primeira <ul>/<p> de dentro, jogando a lista para fora do bloco estilizado.
      if (!isNullOrEmpty(sobre)) {
         html += `<h3 class="h5 fw-bold mb-3">${i18next.t('SobreA')} ${empresaFantasia}</h3>
                  <div class="mb-4 overflow-auto" style="max-height: 200px;">
                     <div class="conteudo-rico">${sobre.replace(/\r\n|\r|\n/g, '<br/>')}</div>
                  </div>`
      }

      if (!isNullOrEmpty(porqueTrabalhar)) {
         html += `<h3 class="h5 fw-bold mb-3">${i18next.t('PorqueTrabalharConosco')}</h3>
                  <div class="mb-4 overflow-auto" style="max-height: 200px;">
                     <div class="conteudo-rico">${porqueTrabalhar.replace(/\r\n|\r|\n/g, '<br/>')}</div>
                  </div>`
      }

      return html;
   };

   const redesSociais = (redesSociaisIcones) => {
      if (redesSociaisIcones.length === 0) {
         return '';
      }

      let redesHtml = redesSociaisIcones.map(rede => {
         return `<a href="${rede.url}" target="_blank" class="text-secondary" title="${rede.url}">
                     <i class="${rede.redeSocialIconeConvertido} hover-rede-social"></i>
                 </a>`;
      }).join('');

      return `<div class="mb-4">
                  <p class="mb-2 fw-semibold">${i18next.t('SigaNossasRedesSociais')}</p>
                  <div class="d-flex gap-3 fs-4">
                     ${redesHtml}
                  </div>
              </div>`;
   };

   const informacoesBasicas = (site, areaNome, anoFundacao, enderecos) => {

      let siteHtml = !isNullOrEmpty(site) ? `
                    <div class="d-xxl-flex flex-wrap mb-3 row-gap-1 column-gap-3 align-items-center">
                        <h6 class="m-xxl-0 informacao-label-min-w fw-semibold">${i18next.t('Site')}</h6>
                        <a href=${site} target="_blank" class="d-flex align-items-center gap-1 text-break">
                            <span>${site}</span>
                            <i class="bi bi-box-arrow-up-right mb-1" style="font-size: 0.75rem;"></i>
                        </a>
                    </div>
                ` : '';

      let areaNomeHtml = !isNullOrEmpty(areaNome) ? `
                    <div class="d-xxl-flex flex-wrap mb-3 row-gap-1 column-gap-3 align-items-center">
                        <h6 class="m-xxl-0 informacao-label-min-w fw-semibold">${i18next.t('Setores')}</h6>
                        <p class="m-0">${areaNome}</p>
                    </div>
                ` : '';

      let anoFundacaoHtml = !isNullOrEmpty(anoFundacao) ? `
                    <div class="d-xxl-flex flex-wrap mb-3 row-gap-1 column-gap-3 align-items-center">
                        <h6 class="m-xxl-0 informacao-label-min-w fw-semibold">${i18next.t('FundadaEm')}</h6>
                        <p class="m-0">${anoFundacao}</p>
                    </div>
                ` : '';

      let enderecosHtml = enderecos.length === 0 ? '' : enderecos.map(item => {
         return `
                        <div class="col-12 mb-2">
                            <p itemprop="address" itemscope itemtype="http://schema.org/PostalAddress" class="mb-0">
                                <strong>${item.titulo}:</strong>
                                <span itemprop="streetAddress">${item.logradouro}, ${item.numero} - ${item.bairro}. CEP: ${item.cep} - ${item.cidadeNome}</span>
                            </p>
                        </div>
                    `
      })

      let enderecoContainerHtml = !isNullOrEmpty(enderecos) && enderecos.length > 0 ? `
                    <div class="col-12">
                        <div class="d-xxl-flex flex-wrap mb-3 row-gap-1 column-gap-3">
                            <h6 class="informacao-label-min-w m-xxl-0 fw-semibold">${i18next.t('Localizacao')}</h6>
                            <div class="container px-0">
                                <div class="row">
                                    ${enderecosHtml.join('')}
                                </div>
                            </div>
                        </div>
                    </div>
                ` : '';

      return `<hr class="my-4" />
               <div class="row">
                     <div class="col-12 col-md-7">
                        ${siteHtml}
                        ${areaNomeHtml}
                     </div>
                     <div class="col-12 col-md-5">
                        ${anoFundacaoHtml}
                     </div>
                     ${enderecoContainerHtml}
               </div>`

   }

   let retornoHtml = capaELogo(data.fotoLogo, data.empresaFantasia, data.fotoCapa)
      + nomeEmpresa(data.empresaFantasia, data.areaNome)
      + imagemVideoApresentacao(data.tipoArquivo, data.arquivoUrl, data.empresaFantasia, data.idVideo)
      + sobreEmpresa(data.empresaFantasia, data.sobre, data.porqueTrabalhar)
      + redesSociais(data.redesSociaisIcones)
      + informacoesBasicas(data.site, data.areaNome, data.anoFundacao, data.enderecos);

   return retornoHtml;

}